import React, { useRef, useState } from 'react';
import PropTypes from "prop-types";
import { dateForDateInputFromState, DateFormat, dateForStateFromDateInput } from "../../Helpers/DateTimeHelper";
import { format } from "date-fns";

const DatePickerButtonInput = (props) => {
    const dateInputRef = useRef();

    const openDatePicker = () => {
        if (dateInputRef.current) {
            dateInputRef.current.showPicker();
        }
    };

    // Handle the date change event
    const handleDateChange = (event) => {
        props.onChange(dateForStateFromDateInput(event.target.value));
    };

    return (
        <div
            style={{
                display: 'inline-block',
                position: 'relative',
            }}
        >
            <input
                type="date"
                ref={dateInputRef}
                value={dateForDateInputFromState(props.date)}
                onChange={handleDateChange}
                min={format(new Date(), DateFormat.MYSQL_DATE)}
                style={{
                    position: 'absolute',
                    visibility: 'hidden',
                    marginBottom: '0',
                }}
            />

            <button className="button secondary round small margin-bottom-0"
                onClick={(e) => openDatePicker()}
            >
                <i className="fa fa-calendar"></i>
            </button>
        </div>
    );
};

DatePickerButtonInput.propTypes = {
    date: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default DatePickerButtonInput;
